import { makeAutoObservable } from "mobx"
import { QDataTypes } from "./index.types"
// import { makePersistable } from "mobx-persist-store"

const Params = new URL(window.location.href).searchParams
const Href = window.location.href
/**
 * AppStore.device -
 * Mobile: 0, Desktop: 1
 */

class AppStore {
  appLoaded: boolean = false
  device: 0 | 1 = 0
  footerVisiblity: boolean = false
  isDepTesting: boolean = Href.includes("depTesting")
  isLocalHost: boolean = window.location.hostname === "localhost"
  isPrerendering: boolean = Params.get("isPrerendering") === "yes"
  ipAddress: string = ""
  windowWidth:any = window.innerWidth

  isProdTesting: boolean = Params.get("prodTesting") === "yes"
  isTesting: boolean = Href.includes("testing")
  isResumeJourney: boolean = Params.get("applicationState") === "resume"
  appFormLoaded: boolean = false // State Updates Only Once To Keep AppForm Mounted Once Its Loaded
  visitedQuoteScreen = false //used to load third party lib on quote page
  appFormFilesLoaded = false // Check if App Form Files are Loaded
  isQuote: boolean = Params.get("depRedirect") === "yes"
  appFormTest: boolean = Params.get("isUAT") === "yes"
  isAppLoaded: boolean = false
  isQDataGlobalMasked: boolean = false // Useful when redirecting DIGI Based QData to Different Product Lines
  isQDataMasked: QDataTypes = {
    dob: false,
    gender: false,
    email: false,
    mobile: false
  }

  constructor() {
    makeAutoObservable(this)
    // makePersistable(this, {
    //   name: "device",
    //   properties: ["device"],
    //   storage: window.localStorage,
    // })
  }
  setWindowWidth = (data:any) => (this.windowWidth = data)

  setAppLoaded = (data: boolean) => (this.appLoaded = data)
  setDevice = (data: 0 | 1) => (this.device = data)
  setFooterVisiblity = (data: boolean) => (this.footerVisiblity = data)
  setLocalHost = (data: boolean) => (this.isLocalHost = data)
  setIpAddress = (data: string) => (this.ipAddress = data)
  setIsTesting = (data: boolean) => (this.isTesting = data)
  setIsResumeJourney = (data: boolean) => (this.isResumeJourney = data)
  setAppFormLoaded = (data: boolean) => (this.appFormLoaded = data)
  setVisitedQuoteScreen = (data: boolean) => (this.visitedQuoteScreen = data)
  setAppFormFilesLoaded = (data: boolean) => (this.appFormFilesLoaded = data)
  setIsQDataMasked = (data: QDataTypes) => (this.isQDataMasked = data)
  setIsQDataGlobalMasked = (data: boolean) => (this.isQDataGlobalMasked = data)
}

export default new AppStore()
